import { areSchedulesEqual } from "@src/features/schedules/utils/schedule-utils";
import { getTimezoneFromAlarmDetail, isPristine } from "@src/features/alarms/utils/alarm-utils";
import { AlarmConfiguration } from "@visioni/a3s-alarm-schedules/schema";

interface DeriveAlarmSettingsViewStateOptions {
  alarmData: AlarmConfiguration;
  userTimezone: string;
}

export function deriveAlarmSettingsViewState({ alarmData, userTimezone }: DeriveAlarmSettingsViewStateOptions) {
  const pristine = isPristine(alarmData);
  const timezone = getTimezoneFromAlarmDetail(alarmData) || alarmData.settings?.timezone || "UTC";

  const configuredSchedule = alarmData.configured?.schedule;
  const firstScheduleApplying = alarmData.applied === null && !!configuredSchedule;

  let schedulesDiffer = false;
  if (alarmData.applied === "configured") {
    schedulesDiffer = false;
  } else if (alarmData.applied === null) {
    schedulesDiffer = configuredSchedule !== null && configuredSchedule !== undefined;
  } else if (typeof alarmData.applied === "object") {
    schedulesDiffer = !areSchedulesEqual(configuredSchedule, alarmData.applied.schedule);
  }

  const cameraTimezone =
    alarmData.settings?.timezone ?? alarmData.configured?.schedule?.metadata?.timezone ?? "Not set";
  const showTimezoneMismatchBanner = cameraTimezone !== "Not set" && cameraTimezone !== userTimezone;

  return {
    pristine,
    timezone,
    configuredSchedule,
    firstScheduleApplying,
    schedulesDiffer,
    cameraTimezone,
    showTimezoneMismatchBanner,
  };
}
